import React from 'react';
import { Col } from 'antd';
import 'src/pages/userComponents/menus/Congratulation page/congratulation.scss';
import TextComponent from '@sharedComponent/typography/TextComponent';
import TimelineComponent from './timelineComponent';
import EdenredButton from '@pages/userComponents/button';

const CongratulationPage = ({ getEmployeeTempletStart, companyInfoCangratulationData, employeeFileLoading }) => {
	return (
		<>
			<div className="main_page_wrapper">
				<Col className="page_wrapper">
					<TextComponent className="heading_2_text">Congratulations!</TextComponent>
					<TextComponent className="text2" style={{ marginTop: '15px' }}>
						<p>You are now joining over 6,000 companies in the UAE who trust Edenred to manage their payroll.</p>
					</TextComponent>

					<TimelineComponent companyInfoCangratulationData={companyInfoCangratulationData}></TimelineComponent>
					<EdenredButton
						disabled={employeeFileLoading}
						onClick={() => getEmployeeTempletStart()}
						loading={employeeFileLoading}
						type={employeeFileLoading ? 'outline_grey' : 'primary'}
						formType="submit"
					>
						Download Employee File
					</EdenredButton>
					<div className="bottom_info_container">
						<TextComponent className="text2" style={{ marginTop: '15px' }}>
							<p>To issue cards, submit your employee file to {companyInfoCangratulationData.ownerEmail}</p>
						</TextComponent>
					</div>
					<div>
						<TextComponent className="text2" style={{ marginTop: '15px' }}>
							<p>You will receive credentials to access the Edenred Payroll Portal within 24 hours along with detailed instructions.</p>
						</TextComponent>
					</div>
				</Col>
			</div>
		</>
	);
};

export default CongratulationPage;
